var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCashBack = function SvgCashBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.587,
    height: 28.596,
    viewBox: "0 0 28.587 28.596",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7769",
    "data-name": "Grupo 7769",
    transform: "translate(-120.506 -209.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5439",
    "data-name": "Caminho 5439",
    d: "M139.508,236.858a14.3,14.3,0,0,1-18.972-14.419.186.186,0,0,0,0,.021c0-.077.011-.155.018-.232a1.611,1.611,0,0,1,3.2.273.093.093,0,0,1,0,.015.431.431,0,0,1,0,.044c0,.042-.006.084-.009.125a11.059,11.059,0,1,0,12.77-10.217,10.894,10.894,0,0,0-7.6,1.539c-.118.073-.232.152-.313.2.356.387.678.751,1.015,1.1a1.1,1.1,0,0,1-.669,1.922q-2.452.3-4.9.6c-1.057.131-1.586-.37-1.464-1.43.192-1.661.4-3.321.606-4.98a1.019,1.019,0,0,1,.7-.885,1.043,1.043,0,0,1,1.139.228c.393.381.768.78,1.07,1.089a31.394,31.394,0,0,1,3.366-1.723,13.968,13.968,0,0,1,15.092,2.84,13.455,13.455,0,0,1,4.441,8.746A14.271,14.271,0,0,1,139.508,236.858Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5440",
    "data-name": "Caminho 5440",
    d: "M162.883,384.45c0,.015,0,.03,0,.044a.432.432,0,0,0,0-.044Z",
    transform: "translate(-39.125 -161.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5441",
    "data-name": "Caminho 5441",
    d: "M258.758,288.627c-.132.434.1.622.46.808a4.192,4.192,0,0,1,1.925,2.061,1.222,1.222,0,0,1-.535,1.668,1.206,1.206,0,0,1-1.644-.6,2.108,2.108,0,0,0-1.869-1.258,1.233,1.233,0,0,0-1.341.9,1.257,1.257,0,0,0,.655,1.518c.89.473,1.791.926,2.686,1.39a3.553,3.553,0,0,1,2.09,3.389,3.486,3.486,0,0,1-2.209,3.339.344.344,0,0,0-.236.374,2.91,2.91,0,0,1-.062.757,1.173,1.173,0,0,1-1.318.859,1.122,1.122,0,0,1-1.028-1.1c.05-.6-.213-.784-.711-.973a4.221,4.221,0,0,1-2.291-2.154,1.218,1.218,0,0,1,.5-1.7,1.2,1.2,0,0,1,1.647.583,2.1,2.1,0,0,0,2,1.224,1.144,1.144,0,0,0,1.219-.889,1.263,1.263,0,0,0-.656-1.519c-.925-.489-1.864-.952-2.79-1.439a3.611,3.611,0,0,1-1.9-2.467A3.652,3.652,0,0,1,256,288.99c.234-.061.32-.146.3-.383a2.254,2.254,0,0,1,.025-.61,1.2,1.2,0,0,1,1.156-.941,1.178,1.178,0,0,1,1.2.928A5.338,5.338,0,0,1,258.758,288.627Z",
    transform: "translate(-122.493 -72.007)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash_back.595bc464.svg";
export { ForwardRef as ReactComponent };